import { memo } from "react"
import "./style.css"
import { useTranslation } from 'react-i18next'
import Header from "../header"


const AuthWrapper = ({ children }) => {

    const { i18n } = useTranslation()

    return (
        <>
            <div className={`login-wrapper ${i18n.language}`} >
                <div className='form-container'>
                    <form className="login-content">
                        <Header />
                        {children}
                    </form>
                </div>
            </div>
        </>
    )
}

export default memo(AuthWrapper)